import {Link} from '@aboutyou/router';
import React from 'react';
import styled from 'styled-components';
import {Image, Props as ImageProps} from '../../atoms/Image/Image';
import {Ratio} from '../../atoms/Image/types';

type Props = {
  description: string;
  imageUrl: string;
  targetUrl?: string;
  ratio?: Ratio;
  disableFixedRatio?: boolean;
  importance?: ImageProps['importance'];
  loading?: ImageProps['loading'];
};

const breakpoints = [
  {
    breakpoint: '(max-width: 767px)',
    columns: 1,
  },
  {
    breakpoint: '(max-width: 1023px)',
    columns: 2,
  },
  {
    columns: 3,
  },
];

export const ImageTile = ({
  description,
  imageUrl,
  targetUrl,
  ratio,
  ref,
  ...props
}: Props & {ref?: React.Ref<HTMLDivElement>}) => {
  return (
    <Wrapper
      as={targetUrl ? Link : 'div'}
      data-testid="imageTile"
      to={targetUrl}
      ref={ref}
    >
      <StyledImage
        alt={description}
        breakpoints={breakpoints}
        data-testid="imageTileView"
        ratio={ratio ?? '3:4'}
        src={imageUrl}
        {...props}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div<{to?: string}>`
  contain: content;
  content-visibility: auto;
`;

const StyledImage = styled(Image)`
  object-fit: cover;
`;
